import React from 'react';
import "./CookiesPopup.css"
import CookieConsent from "react-cookie-consent";

const CookiesConsent = () => {
  const [showPopup, setShowPopup] = React.useState(true);

  return (

    <CookieConsent 
      location="bottom"
      buttonText="Got It !"
      cookieName="AcceptCookies"
      style={{ background: "#2B373B", textAlign: "center" }}
      buttonStyle={{
        color: "black",
        fontSize: "1.2em",
        marginRight: '30px',
        backgroundColor: 'rgb(139, 237, 79)',
        fontWeight: 'bolder',
        borderRadius: '5px',
        minHeight: '50px',
        borderStyle: 'solid',
        borderWidth: '5px',
        padding: '0.4em 0.5e',
        borderColor: 'transparent',
        textAlign: 'center',
        whiteSpace: 'nowrap'
      }}
      expires={5}
    >
      <span className="cookie-text">We use cookies to ensure you have the best browsing experience on our website. By using our site, you
        acknowledge that you have read and understood our &nbsp;
        <a href="/legal/privacy-policy" target="_blank"><u>Terms &amp; Use.</u></a></span>
    </CookieConsent>
  );
};

export default CookiesConsent;
